import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-account-settings',
    templateUrl: './icon-account-settings.component.html',
    styleUrls: ['./icon-account-settings.component.scss']
})
export class IconAccountSettingsComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
